<template>
    <el-dialog custom-class="change_password_dialog" :model-value="show" width="422px" destroy-on-close :lock-scroll="false" @close="handleClose" @open="handleOpen">
        <div class="validate_dialog_content">
            <div class="close" @click="handleClose">
                <Close class="icon" />
            </div>
            <div class="title_iocn"><i class="iconfont icon-mima"></i></div>
            <h1>修改密码</h1>
            <AnimationInput type="password" v-model.trim="form.oldPassword" maxlength="32" name="oldPassword" placeholder="旧密码" :autoFocus="true" /><br />
            <AnimationInput type="password" v-model.trim="form.newPassword" maxlength="32" name="newPassword" placeholder="新密码" :autoFocus="false" /><br />
            <AnimationInput type="password" v-model.trim="form.checkPassword" maxlength="32" name="checkPassword" placeholder="确认新密码" :autoFocus="false" /><br />
            <div class="btn_box" v-loading="loading">
                <button @click="validate">确认修改</button>
                <button @click="handleClose">取消</button>
            </div>
        </div>
    </el-dialog>
</template>

<script setup>
import { ref, reactive, computed } from "vue";
import AnimationInput from "@/components/common/AnimationInput.vue";
import { Close } from "@element-plus/icons-vue";
import { ElMessage } from "element-plus";
import { apiCommonUpdatePassword } from "@/request/api";
import md5 from "md5";
import outLogin from "@/utils/outLogin";

const props = defineProps({
    show: { type: Boolean, default: false },
    user: { type: Object, default: {} },
});
const emits = defineEmits(["close"]);
const form = reactive({
    oldPassword: "",
    newPassword: "",
    checkPassword: "",
});
const loading = ref(false);
const params = computed(() => {
    return {
        oldPassword: md5(form.oldPassword).toLocaleLowerCase(),
        newPassword: md5(form.newPassword).toLocaleLowerCase(),
    };
});

// 验证
function validate() {
    const { oldPassword, newPassword, checkPassword } = form;
    if (!oldPassword) {
        ElMessage.error("请输入旧密码");
        return;
    }
    if (!newPassword) {
        ElMessage.error("请输入新密码");
        return;
    }
    if (!checkPassword) {
        ElMessage.error("请再次输入新密码");
        return;
    }
    if (newPassword.length < 8) {
        ElMessage.error("密码长度不能低于8位");
        return;
    }
    if (newPassword !== checkPassword) {
        ElMessage.error("两次密码不一致");
        return;
    }
    submit();
}

async function submit() {
    loading.value = true;
    try {
        const { code } = await apiCommonUpdatePassword(params.value);
        if (code !== "0") return;
        ElMessage.success("修改成功，请重新登录");
        outLogin();
    } finally {
        loading.value = false;
    }
}

// 打开
function handleOpen() {}

// 关闭
function handleClose() {
    form.oldPassword = "";
    form.newPassword = "";
    form.checkPassword = "";
    loading.value = false;
    emits("close");
}
</script>

<style lang="scss">
.change_password_dialog {
    border-radius: 16px;
    .el-dialog__header {
        display: none;
    }
    .el-dialog__body {
        padding: 0;
    }
    .validate_dialog_content {
        padding: 34px;
        position: relative;
        text-align: center;
        .close {
            position: absolute;
            top: 32px;
            right: 32px;
            cursor: pointer;
            .icon {
                width: 24px;
                height: 24px;
            }
        }
        .title_iocn {
            width: 68px;
            height: 68px;
            border-radius: 8px;
            background-color: #ff5a00;
            margin: 0 auto;
            display: flex;
            align-items: center;
            justify-content: center;
            .iconfont {
                color: #fff;
                font-size: 24px;
            }
        }
        h1 {
            color: #2a2a2a;
            font-size: 24px;
            line-height: 28px;
            margin-top: 24px;
            font-weight: 400;
        }
        h2 {
            color: #727272;
            font-size: 14px;
            line-height: 28px;
            margin-top: 16px;
            font-weight: 400;
            padding: 0 27px;
            margin-bottom: 16px;
            span {
                color: #2a2a2a;
                font-size: inherit;
            }
        }
        .btn_box {
            padding-top: 48px;
            display: flex;
            justify-content: space-between;
            button {
                width: 168px;
                height: 68px;
                border-radius: 8px;
                font-size: 20px;
                display: flex;
                align-items: center;
                justify-content: center;
                &:first-child {
                    background-color: var(--week-primary-color);
                    color: #fff;
                }
                &:last-child {
                    background-color: #f5f5f5;
                    color: #2a2a2a;
                }
                span {
                    font-size: inherit;
                }
            }
        }
    }
}
</style>
